import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { Dashboard } from 'src/shared/models/dashboard.model';

@Injectable({
    providedIn: 'root'
})
export class SharedDashboardService {

    constructor(
        private cvApiService: CVApiService,
    ) { }

    public async getDashboard(sharedKey: string): Promise<Dashboard> {
        try {
            const url = `/api/v2/GetDashboardBySharedKey?sharedKey=${sharedKey}`;
            const response = await this.cvApiService.get<Dashboard>(url);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        } catch (error) {
            console.error('Failed getting dashboard');
        }
    }

    public async logout() {
        try {
            const url = '/api/v1/logout';
            this.cvApiService.get(url);
        } catch (error) {
            console.error('Failed logging out');
        }
    }
}
